import { Component, ComponentPublicInstance, createApp, DefineComponent } from "vue";
import clickOutsideDirective from "./clickOutsideDirective";
import Toast from "vue-toastification";
import VueTelInput from "./VueTelInput/index";
import "./VueTelInput/assets/sprite.css";
import "vue-toastification/dist/index.css";
import { createPinia } from "pinia";

export type PropsToInstance = (props: Record<string, unknown>) => ComponentPublicInstance;

export function vueApp(component: Component | DefineComponent): PropsToInstance {
    return (props: Record<string, unknown>): ComponentPublicInstance =>
        createApp(component, props).directive("click-outside", clickOutsideDirective).use(Toast).use(VueTelInput).mount(".panel-app");
}

/**
 * @deprecated Use pinia store instead.
 */
export function vueAppWithStore(component: Component | DefineComponent, store, usePinia: boolean = false): PropsToInstance {
    return (props: Record<string, unknown>): ComponentPublicInstance => {
        let appBuilder = createApp(component, props)
            .use(store)
            .directive("click-outside", clickOutsideDirective)
            .use(Toast)
            .use(VueTelInput);

        if (usePinia) {
            appBuilder = appBuilder.use(createPinia());
        }

        return appBuilder.mount(".panel-app");
    };
}

export function vueAppWithPinia(component: Component | DefineComponent): PropsToInstance {
    const pinia = createPinia();

    return (props: Record<string, unknown>): ComponentPublicInstance =>
        createApp(component, props)
            .directive("click-outside", clickOutsideDirective)
            .use(Toast)
            .use(VueTelInput)
            .use(pinia)
            .mount(".panel-app");
}
